<template>
	<div class="privacy_policy">
		<div class="body">
			<div id="main-content" class="wiki-content">
				<div style="margin-bottom:15px;">
					<p class="p" align="center"><strong>租车通隐私政策</strong></p>
				</div>
				<p class="p" style="margin-bottom:15px;"><strong>引言</strong></p>
				<p class="p">
					租车通网站/移动端/微信公众号/WAP（“租车通”）及其运营主体广州力挚网络科技有限公司（“我们”）非常重视用户（“您”）的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《租车通隐私政策》（“隐私政策”）向您说明我们在您使用我们的产品与服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
				</p>
				<p class="p">本政策将帮助您了解以下内容：</p>
				<p class="p">1、我们如何收集和使用您的个人信息</p>
				<p class="p">2、我们如何使用Cookies和同类技术</p>
				<p class="p">3、我们如何共享、转让、公开披露您的个人信息</p>
				<p class="p">4、我们如何保护和保存您的个人信息</p>
				<p class="p">5、您如何管理个人信息</p>
				<p class="p">6、未成年人信息的保护</p>
				<p class="p">7、我们如何处理儿童的个人信息</p>
				<p class="p">8、通知和修订</p>
				<p class="p">9、如何联系我们</p>
				<p class="p">
					<strong
						>请您在使用我们的产品与服务前仔细阅读并确认您已经充分理解本政策的内容，您使用或在我们更新本隐私政策后继续使用我们的产品与服务，即视为您同意本隐私政策内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</strong
					>
				</p>
				<p class="p">
					如对本隐私政策有任何问题，您可随时通过我们的在线客服与我们联系。
				</p>
				<p
					id="id-测试-一、我们如何收集和使用您的个人信息"
					style="margin:15px 0;"
				>
					<strong>一、我们如何收集和使用您的个人信息</strong>
				</p>
				<p class="p">
					个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
				</p>
				<p class="p">
					我们在提供产品和服务的过程中可能涉及的个人信息包括：基本信息（包括个人姓名、住址、个人电话号码）；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（交易和消费记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/android
					ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）
				</p>
				<p class="p">
					<strong>个人敏感信息</strong
					>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，<strong
						>本隐私政策中涉及的个人敏感信息包括：您的个人身份信息（包括身份证）；网络身份识别信息（包括租车通账号）；其他信息（包括个人手机号码）。</strong
					>
				</p>
				<p class="p">我们基于以下目的收集和使用您的个人信息：</p>
				<p class="p">
					<strong>（一）您须授权我们收集和使用您个人信息的情形</strong
					><strong><br /></strong
					><strong
						>我们的产品与/或服务（包括境内租车、境外租车、驾照翻译认证件（TIDL）、探途地图、网红地图、门票服务、会员特权等现有，以及未来开展的产品销售或服务。下称产品或服务）含有一些核心功能，这些功能包含了实现产品或服务所必须的功能、改进我们的产品与/或服务所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：</strong
					>
				</p>
				<p class="p"><strong>1、实现网上购买产品或服务所必须的功能</strong></p>
				<p class="p"><strong>（1）用户注册</strong></p>
				<p class="p">
					当您下载、注册、登录或向租车通及相关应用购买产品/服务时，向我们提供如下信息：<strong>电话号码、用户名、其他注册信息。</strong>我们可能使用您提供给我们的信息来联系您，不时地为您提供重要信息、必要的通知等。对于某些功能，如向我们注册账号属于非强制性质。
				</p>
				<p class="p"><strong>（2）租车及相关服务</strong></p>
				<p class="p">
					当您使用租车等产品或服务时，为了与境内外车行有效联系以确保您能够租到合适的车辆，与相关翻译认证机构联系以为您制作翻译认证件，与保险公司等合作为您提供保险服务等，我们会根据必要性原则，收集<strong>您的姓名、出生日期、驾照类型、电话号码及电子邮件等信息以向您提供相关产品或服务</strong>。
				</p>
				<p class="p"><strong>（3）页面搜索</strong></p>
				<p class="p">
					基于系统安全风控的考虑，也为了不断改进和优化我们的产品功能，当您使用页面搜索功能时，我们会收集<strong>您的搜索查询的内容、点击的链接、发布的报错消息、反馈和评论的内容、您上传的图片以及您的IP地址、设备信息、浏览器的类型和使用的语言、操作系统版本、网络运营商的信息、访问服务时间</strong>。
				</p>
				<p class="p"><strong>（4）社交功能</strong></p>
				<p class="p">
					当您使用社交功能（包括自驾圈群聊、问答、游记、视频等）时，由于您的主动披露，<strong>您的昵称、肖像、行程、分享内容等信息</strong>会通过我们发布于平台特定板块，以方便您社交的需要。在信息主动披露的过程中，请您提高警惕，慎重发言及选择披露内容。
				</p>
				<p class="p"><strong>（5）第三方服务</strong></p>
				<p class="p">
					为了使您的生活和旅行更加充实、便捷，我们的产品可能会集成第三方的SDK或其他类似的应用程序，这些公司会严格遵守我们的数据隐私和安全要求。除非得到您的同意，我们不会与其共享您的个人身份信息。<strong>为便于您更好地了解第三方SDK所采集的数据类型及用途，以及保护您的个人信息，您可以通过附件链接【第三方SDK合作伙伴与共享信息说明】了解到具体的权限及对应的隐私权政策。</strong>我们理解并尊重您的选择权，如果您不愿参与大数据计算，您也可以通过第三方SDK合作伙伴与共享信息说明的链接指引行使opt-out（即用户退出并断开与第三方SDK合作伙伴的信息共享）的权利。
				</p>
				<p class="p"><strong>（6）客服咨询与售后</strong></p>
				<p class="p">
					当您使用的客户端软件频繁向我们进行报错或显示错误日志信息时，为了检查软件错误，给您提供更好的服务，我们会在您的设备上记录、收集您的配置信息、异常数据等用于诊断并完善产品及服务的文件。当您与租车通联系时，为了方便与您联系或帮助您解决问题，<strong>我们可能会记录您的联系方式、身份信息，并结合需要记录您的通话内容</strong>。
				</p>
				<p class="p"><strong>2、改进我们的产品或服务所必须的功能</strong></p>
				<p class="p">
					<strong
						>我们可能会收集您的订单信息、浏览信息、您的兴趣爱好（可选）进行数据分析以形成用户画像，以匹配您可能感兴趣的商品或服务以提高您的购买决策效率。</strong
					>我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时的答复信息，以及您与我们的合作伙伴互动时我们获得的相关信息。对于我们收集到的信息，我们可能会将它们进行关联，以便我们能为您提供更好的服务。
				</p>
				<p class="p"><strong>3、保障交易安全所必须的功能</strong></p>
				<p class="p">
					为提高您使用我们的产品或服务时系统的安全性，预防不法分子利用钓鱼网站欺诈、黑客进攻、不法分子数据撞库等威胁您的账户及支付安全，我们可能会通过了解您的浏览信息、订单信息、您常用的软件信息、设备信息等手段来判断您所面临的风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。
				</p>
				<p class="p">
					<strong
						>（二）您可选择是否授权我们收集和使用您的个人信息的情形</strong
					>
				</p>
				<p class="p">
					1、为使您使用我们的产品或服务时更便捷或更有乐趣，从而提升您通过租车通产品或服务获得更好的体验，<strong
						>我们在技术能力具备的情况下会开放并供您选择性使用以下附加功能，这些附加功能的使用与否取决于您是否做出明示性的选择。在使用这些功能的过程中，我们可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以进行网上购买产品或服务，只是您将无法因为使用这些附加功能而获得更多的便捷和乐趣：</strong
					>
				</p>
				<p class="p">
					<strong
						>（1）基于位置信息的个性化推荐功能：我们会收集您的位置信息（我们仅收集您当时所处的地理位置来判断您所处的地点，并自动为您推荐您所在区域可以购买的商品或服务。</strong
					>比如向您推荐离您最近的可选的购物商场。
				</p>
				<p class="p">
					<strong>（2）摄像头拍照功能：</strong
					>您可以使用这个附加功能完成视频拍摄、拍照、扫码的功能。
				</p>
				<p class="p">
					<strong>（3）基于图片上传的附加功能：</strong
					>您可以上传您的照片来实现自驾圈游记和晒单及评价功能，<strong
						>您上传的照片及相关叙述可供其他用户用作行程规划及境外租车参考。</strong
					>
				</p>
				<p class="p">
					<strong>（4）语音识别与处理功能：</strong
					>您可以使用麦克风来进行语音与我们的客服进行咨询和互动。<strong
						>我们会收集您的录音内容以识别您和客服与售后传达的的需求。</strong
					>
				</p>
				<p class="p">
					（5）通讯录信息收集和调用功能：<strong
						>我们将收集您的通讯录信息以方便您在购买产品/服务时不再手动输入您通讯录中联系人的信息（比如您可以直接为通讯录中的电话号码充值）。</strong
					>
				</p>
				<p class="p">
					<strong
						>您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能。您后续可关闭相关权限授权，我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前已经过您授权所进行的个人信息的处理。</strong
					>
				</p>
				<p class="p">
					<strong
						>（三）在以下情况下，我们收集、使用个人信息无需征得您的授权同意：</strong
					>
				</p>
				<p class="p">
					<strong>1、与国家安全、国防安全有关的；</strong><strong><br /></strong
					><strong>2、与公共安全、公共卫生、重大公共利益有关的；</strong
					><strong><br /></strong
					><strong>3、与犯罪侦查、起诉、审判和判决执行等有关的；</strong
					><strong><br /></strong
					><strong
						>4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</strong
					><strong><br /></strong
					><strong
						>5、所收集的个人信息是个人信息主体自行向社会公众公开的；</strong
					><strong><br /></strong
					><strong
						>6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</strong
					><strong><br /></strong
					><strong>7、根据您的要求签订及履行合同所必需的；</strong
					><strong><br /></strong
					><strong
						>8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</strong
					><strong><br /></strong><strong>9、法律法规规定的其他情形。</strong>
				</p>
				<p class="p"><strong>（四）我们从第三方获得您个人信息的情形</strong></p>
				<p class="p">
					我们可能从第三方获取您授权共享的账户信息（头像、昵称）如微信授权登录，并在您同意本隐私政策后将您的第三方账户与您的租车通账户绑定，使您可以通过第三方账户登录并使用我们的产品与服务。<strong
						>我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</strong
					>
				</p>
				<p class="p"><strong>（五）您个人信息使用的规则</strong></p>
				<p class="p">
					1、我们会严格依据本隐私政策的约定对所收集的个人信息进行使用。<br />2、<strong
						>在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。我们有权对用户数据库进行分析并予以商业化的利用。</strong
					><br />3、<strong
						>您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除、通过系统设置拒绝我们收集、因系统设置了特定的有效期限且已到达期限，否则将在您使用我们的产品和服务期间持续授权我们使用。</strong
					><br />4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。<br />5、当我们要将您的个人信息用于超出本政策约定用途时，我们会另行征求您的同意。
				</p>
				<p
					id="id-测试-二、我们如何使用Cookies和同类技术"
					style="margin:15px 0;"
				>
					<strong>二、我们如何使用Cookies和同类技术</strong>
				</p>
				<p class="p"><strong>（一）Cookies的使用</strong></p>
				<p class="p">
					1、为向您提供更便捷的用户体验，简化您重复登录的步骤、存储您的偏好或您购物车中的商品等数据进而为您提供购物的偏好设置、优化对广告的选择与互动、判断您的登录状态以及账户或数据安全，我们会在您的计算机或移动设备上发送一个或多个名为Cookies的小数据文件。
				</p>
				<p class="p">
					2、我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookies；另外，您也可以清除软件内保存的所有Cookies。但清除后，您可能需要在每一次访问租车通隐私政策网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。
				</p>
				<p class="p"><strong>（二）网络Beacon和同类技术的使用</strong></p>
				<p class="p">
					除Cookies外，我们还会在网站上使用网络Beacon等其他同类技术。我们的网页上常会包含一些电子图像（称为“单像素”GIF文件或“网络Beacon”）。我们使用网络Beacon的方式有：<br />1、通过在网站上使用网络Beacon，计算用户访问数量，并通过访问Cookies辨认注册的用户。&nbsp;<br />2、通过得到的Cookies信息，为您提供个性化服务。
				</p>
				<p
					id="id-测试-三、我们如何共享、转让、公开披露您的个人信息"
					style="margin:15px 0;"
				>
					<strong>三、我们如何共享、转让、公开披露您的个人信息</strong>
				</p>
				<p class="p"><strong>（一）共享</strong></p>
				<p class="p">
					<strong
						>1、原则上，我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</strong
					><br />（1）事先获得您明确的同意或授权；<br />（2）根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；<br />（3）在法律法规允许的范围内，为维护我们、我们的关联方或合作伙伴、您或其他用户或社会公众利益、财产或安全免遭损害，合理维权而有必要提供；<br />（4）只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务；<br />（5）应您需求为您处理您与他人的纠纷或争议；<br />（6）符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br />（7）基于学术研究而使用；<br />（8）基于符合法律法规、社会公共利益而使用。
				</p>
				<p class="p">
					<strong
						>2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</strong
					>
				</p>
				<p class="p">
					<strong
						>3、我们会基于为您提供服务目的而向合作伙伴等第三方共享您的订单信息、账户信息等，但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</strong
					>我们的合作伙伴包括以下类型：
				</p>
				<p class="p">
					（1）商品或技术服务的供应商。<strong>我们可能会将您的个人信息共享给支持我们功能的第三方。</strong>这些支持包括为我们的供货服务、物流配送服务、支付服务、数据处理、驾照翻译认证等。我们共享这些信息的目的是可以实现我们产品或服务的核心购物功能，比如我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。
				</p>
				<p class="p">
					（2）商品销售商或第三方商家。<strong
						>我们必须将您的订单信息与交易有关的必要信息与商品销售商、第三方商家共享来实现您向其购买商品或服务的需求，并促使其可以完成后续的售后服务。如保险，会员特权等产品或服务。</strong
					>
				</p>
				<p class="p">
					（3）委托我们进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。<strong
						>我们可能会使用您的个人信息以及您的非个人信息集合形成的间接用户画像与委托我们进行推广的合作伙伴（“委托方”）共享，但我们会进行相应的匿名处理，以便它不会识别您个人。</strong
					>
				</p>
				<p class="p">
					4、对我们与之共享个人信息的公司、组织和个人，其依法应当对您的个人信息予以保护。我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
				</p>
				<p class="p"><strong>（二）转让</strong></p>
				<p class="p">
					我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br />1、事先获得您明确的同意或授权；<br />2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；<br />3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；<br /><strong
						>4、在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意。</strong
					>
				</p>
				<p class="p"><strong>（三）公开披露</strong></p>
				<p class="p">
					我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：<br />1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br />2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。我们会对所有的请求都进行慎重审查，以确保其合法有据。
				</p>
				<p
					id="id-测试-四、我们如何保护和保存您的个人信息"
					style="margin:15px 0;"
				>
					<strong>四、我们如何保护和保存您的个人信息</strong>
				</p>
				<p class="p">
					<strong>（一）我们保护您个人信息的技术与措施</strong
					><br />我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：<br /><strong
						>1、数据安全技术措施</strong
					><br />我们会采用符合业界标准的安全防护措施，包括建立合理的安全技术，如加密技术来收集、存储，防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失；我们建立健全相应的制度流程规范以确保您的个人信息安全。<br />我们采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。<br />我们采用代码安全自动检查、数据访问日志记录与分析技术进行个人信息安全审计。
				</p>
				<p class="p"><strong>2.人员意识教育</strong></p>
				<p class="p">
					我们致力于加强安全意识，举办安全和隐私保护培训课程，<strong
						>加强员工对于保护个人信息重要性的认识。</strong
					>
				</p>
				<p>1.&nbsp;<strong>数据接触控制</strong></p>
				<p class="p">
					<strong
						>我们仅允许有必要知晓这些信息的的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被终止与我们的合作关系。</strong
					>
				</p>
				<p class="p"><strong>4.数据事件应急处理</strong></p>
				<p class="p">
					为应对个人信息泄露、损毁和丢失等可能出现的风险，我们建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施。
				</p>
				<p class="p">
					<strong
						>在发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将通过站内信、邮件、电话、短信等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</strong
					>
				</p>
				<p class="p">
					互联网环境并非百分之百安全，我们将尽力对您发送给我们的任何信息进行安全保护。如果因我们的过错，导致在物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
				</p>
				<p class="p">
					如果您对我们的个人信息保护有任何疑问，可联系我们的客服予以反馈。<strong
						>如您发现自己的个人信息泄密，尤其是您的账户及密码发生泄露，请您立即与我们联系以便我们采取相应措施。</strong
					>
				</p>
				<p class="p"><strong>（二）您个人信息的保存</strong></p>
				<p class="p">
					<strong>1、您的个人信息将全被存储于中华人民共和国境内。</strong>
				</p>
				<p class="p">
					<strong
						>2、当您申请注销租车通账号后，我们将在您提出申请后对您的账户注销申请进行审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。</strong
					>
				</p>
				<p class="p">
					<strong
						>3、当我们需要终止服务或运营，我们会提前十五个工作日通知您，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</strong
					>
				</p>
				<p id="id-测试-五、您如何管理您的个人信息" style="margin:15px 0;">
					<strong>五、您如何管理您的个人信息</strong>
				</p>
				<p class="p">
					我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除等权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
				</p>
				<p class="p"><strong>1、访问和更正您的个人信息</strong></p>
				<p class="p">
					除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：
				</p>
				<p class="p">
					（1）您的账户信息：可以在租车通首页页面的<strong>“我的---账户设置”</strong>中查阅您提交给我们的基本个人信息。
				</p>
				<p class="p">
					（2）您的订单信息：您可以通过访问“我的订单”页面查看，或联系我们的客服了解您的已经完成、待评价、待退款的订单。<strong
						>您可以选择删除订单来删除您的订单信息，但这样可能导致我们无法准确判断您的购买信息而难以提供相应的售后服务。</strong
					>
				</p>
				<p class="p">
					（3）对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
				</p>
				<p class="p">
					（4）您无法访问和更正的个人信息：除上述列明可查询及修改的信息外，您的部分个人信息暂无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息。上述信息我们会在您的授权范围内进行使用，您可联系我们进行删除或做匿名化处理。
				</p>
				<p class="p"><strong>2、删除您的个人信息</strong></p>
				<p class="p">您可以直接联系我们清除或删除您的个人信息。</p>
				<p class="p">
					<strong>在以下情形中，您可以向我们提出删除个人信息的请求：</strong>
				</p>
				<p class="p">
					（1）如果我们处理个人信息的行为违反法律法规；<br />（2）如果我们收集、使用您的个人信息，却未征得您的同意；<br />（3）如果我们处理个人信息的行为违反了与您的约定；<br />（4）如果我们终止服务及运营。<br />若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体另行获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
				</p>
				<p class="p"><strong>3、</strong>注销账户</p>
				<p class="p">
					您可以通过租车通APP-我的-页面设置-账户安全-申请注销；联系我们的在线客服，或拨打租车通的客服电话申请注销账户（中国大陆拨打：1010-1020；其他地区拨打：+86-10-6064-1387）。注销租车通账户后，您该账户内的所有信息将被清空或匿名化，我们将不会再收集、使用或共享与该账户相关的个人信息。
				</p>
				<p class="p">
					3.2您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息或匿名化处理，并不再进行任何技术利用。
				</p>
				<p class="p">3.3注销租车通账户，视为您放弃以下权益：</p>
				<p class="p">（1）账户信息、订单信息、会员权益、虚拟资产；</p>
				<p class="p">（2）利用会员卡号、验证手机或邮箱登陆租车通；</p>
				<p class="p">（3）解除与第三方授权或绑定关系。</p>
				<p class="p">
					您理解并同意，我们将及时通知授权或绑定关系的第三方，删除您的有关信息，但无法监控第三方的执行。同样的，<strong
						>我们无法协助您重新恢复前述服务，您注销账户的行为会给您的售后维权带来诸多不便，请您在操作之前，确保您的账户无任何纠纷，并自行备份账户相关的所有信息和数据，下载并保存好订单商品和服务的交易凭证、票据（如电子发票）等资料。</strong
					>
				</p>
				<p class="p"><strong>4、拒绝推送</strong></p>
				<p class="p">
					<strong
						>如果您不想接受我们给您发送的促销信息，您可以随时回复“TD”来取消我们给您发送的手机促销短信。</strong
					>
				</p>
				<p class="p">
					您在行使相关权利时遇到问题或有任何意见建议，您均可以通过我们的在线客服与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的十五个工作日内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
				</p>
				<p class="p">
					在以下情形中，按照法律法规要求，我们将无法响应您的请求：<br />（1）与国家安全、国防安全有关的，可能造成相应损害的；<br />（2）与公共安全、公共卫生、重大公共利益有关的，可能造成相应损害的；<br />（3）与犯罪侦查、起诉和审判等有关的，可能损害相关利益的；<br />（4）有充分证据表明您存在主观恶意或滥用权利的；<br />（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
				</p>
				<p
					id="id-测试-六、关于未成年人的个人信息保护安排"
					style="margin:15px 0;"
				>
					<strong>六、关于未成年人的个人信息保护安排</strong>
				</p>
				<p class="p">
					1、我们非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，<strong>应事先取得监护人的书面同意。</strong>我们根据国家相关法律法规的规定保护未成年人的个人信息。
				</p>
				<p class="p">
					2、对于监护人同意而收集未成年人个人信息的情况，我们在在法律法规允许、监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
				</p>
				<p class="p">
					3、如果我们发现自己在未事先获得监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据且不做任何其他安排。
				</p>
				<p id="id-测试-七、我们如何处理儿童的个人信息" style="margin:15px 0;">
					<strong>七、我们如何处理儿童的个人信息</strong>
				</p>
				<p
					id="id-测试-我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。"
				>
					我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
				</p>
				<p id="id-测试-八、通知和修订" style="margin:15px 0;">
					<strong>八、通知和修订</strong>
				</p>
				<p class="p">
					1、基于国家法律法规的变化，以及为持续优化我们的服务，本隐私政策也会随之更新。但我们不会主动削减您依据本隐私政策所应享有的权利。我们会通过网站、移动端上发出更新版本，也请您访问隐私政策以便及时了解最新的隐私政策。
				</p>
				<p class="p">
					2、对于服务模式发生重大变化、所有者变更等重大变更，我们还会提供更为显著的通知。
				</p>
				<p style="margin:15px 0;" id="id-测试-九、如何联系我们">
					<strong>九、如何联系我们</strong>
				</p>
				<p class="p">
					1、如您有任何与个人信息保护或隐私保护相关的问题、意见或建议，您可以通过我们在线客服或致电租车通24小时客服热线1010-1020与我们联系。
				</p>
				<p class="p">
					2、一般情况下，我们将在十五个工作日内回复。如果您认为我们的个人信息处理行为损害了您的合法权益，您还可以向市场监管、网信、电信、公安等监管部门进行投诉或举报。
				</p>
				<p class="p">
					<strong
						>注：本《租车通隐私政策》版本更新日期为2021年2月1日，于2021年2月2日正式生效。</strong
					>
				</p>
				<p class="p" align="right">广州力挚网络科技有限公司</p>
				<p class="p" align="left"></p>
				<p class="p" align="left">*附件链接：</p>
				<p class="p" align="left">
					<a
						style="color: #2c3e50;"
						href="https://account.zuzuche.com/user/terms_sdk.html"
						>第三方SDK合作伙伴与共享信息说明</a
					>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { onStatisticsEvent } from "@/utils/native";
export default {
	components: {},
	data() {
		return {};
	},
	computed: {},
	created() {},
	mounted() {
		onStatisticsEvent("page", "租车通隐私政策");
	}
};
</script>
<style lang="scss" scoped>
.privacy_policy {
}
p {
	margin: 0;
}
strong {
}
.body {
	font-size: 12px;
	padding: 15px;
}
.title {
	display: block;
	text-align: center;
	font-weight: bold;
}
.content {
	text-align: left;
	line-height: 1.5;
	div {
		margin-bottom: 15px;
	}
}
</style>
